import { render } from "./SwitchHorizontalIcon.vue?vue&type=template&id=4796bbae"
import script from "./SwitchHorizontalIcon.vue?vue&type=script&lang=js"
export * from "./SwitchHorizontalIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__